export const TYPES = {
  SET_DEFAULT_DEBUG_ALL: "default_debug/SET_DEFAULT_DEBUG_ALL",
  SET_DEFAULT_DEBUG_OPEN_ADD:
    "default_debug/SET_DEFAULT_DEBUG_OPEN_ADD",
  SET_DEFAULT_DEBUG_OPEN_EDIT:
    "default_debug/SET_DEFAULT_DEBUG_OPEN_EDIT",
  SET_DEFAULT_DEBUG_SELECTED:
    "default_debug/SET_DEFAULT_DEBUG_SELECTED",
  SET_DEFAULT_DEBUG_SEARCH: "default_debug/SET_DEFAULT_DEBUG_SEARCH",
};
